import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import TermService from "../../services/Department/TermService";
import { FaSpinner } from 'react-icons/fa';

const TermSelector = ({ onTermChangeEvent }) => {
  const params = new URLSearchParams(window.location.search);
  const deptId = params.get("deptId")
  
  const [isLoading, setIsLoading] = useState(false);
  const [terms, setTerms] = useState([]);
  const [currentCalenderYear	, setCurrentCalenderYear] = useState("");
  const [currentSemester, setCurrentSemester] = useState("");
  const [selectedTerm, setSelectedTerm] = useState(0);

  useEffect(() => {
    fetchTerms(deptId);
  }, []);

  const fetchTerms = (deptId) => {
    setIsLoading(true)
    TermService.GetByDepartmentId(deptId)
      .then(response => {
        const terms = response.data || response;
        
        terms.sort((a, b) => {
          if (b.academicYearId !== a.academicYearId) {
            return b.academicYearId - a.academicYearId;
          }
          return b.termType - a.termType;
        })
        setTerms(terms)
        
        // Get values from the first object in the array
        const currentCalenderYear = terms[0]?.currentCalenderYear;
        const currentSemester = terms[0]?.currentSemester;
        
        setCurrentCalenderYear(currentCalenderYear)
        setCurrentSemester(currentSemester)
        
        //Dont delete
        const currentTerm = terms.find(term => 
          term.academicYearName === currentCalenderYear && 
          term.termTypeStr === currentSemester
        )
        
        if(currentTerm){
          onTermChange(currentTerm.id, currentTerm)
        }
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
        console.error('Error fetching page content:', error);
      })
  };
  const onTermChange = (termId, selectedTerm) =>{
    setSelectedTerm(termId)
    if(!selectedTerm){
      selectedTerm = terms.find(term => term.id == termId)
    }
    onTermChangeEvent(termId, selectedTerm)
  }

  return (
    <div className="d-flex align-items-center mb-3 gap-3">
        <span className="fw-bold">Term:</span>
        {isLoading ? (
          <div className="d-flex align-items-center">
            <FaSpinner className="spinner-border text-primary" style={{ width: '1rem', height: '1rem' }} />
            <span className="ms-2">Loading terms...</span>
          </div>
        ) : (
          <select
            aria-label="Select Term"
            className="form-select"
            value={selectedTerm}
            onChange={(e) => onTermChange(e.target.value)}
            style={{ width: "13em" }}
            disabled={isLoading || terms.length === 0}
          >
            {terms.length > 0 ? (
              terms.map((term, index) => (
                <option key={index} value={term.id}>{term.termAcademicYear}</option>
              ))
            ) : (
              <option value="">No terms available</option>
            )}
          </select>
        )}
    </div>
  );
};

export default TermSelector;